import React from 'react';
import { Calendar, Clock, Building2, Video, Plus, Search, Filter, ChevronDown, List, CalendarDays, Eye, Edit, Trash2, AlertCircle, CheckCircle, Loader, X, ChevronLeft, ChevronRight, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, Zap } from 'lucide-react';
import Select from '@/components/ui/Select';
import Input from '@/components/ui/Input';

const FilterSection = ({ 
filters, 
setFilters,
setShowFilters,
showFilters,
setViewMode,
viewMode,
companyOptions
}) => {



const statusOptions = [
{ label: 'All', value:''},
{ label: 'Scheduled', value:'scheduled'},
{ label: 'In progress',value:'in_progress'},
{ label: 'Completed',value:'completed'},
{ label: 'Cancelled',value:'cancelled'},
{ label: 'Rescheduled',value:'rescheduled'},
];


const typeOptions = [
{ label: 'All', value:''},
{ label: 'Real', value:'real'},
{ label: 'Mock preparation',value:'mock_preparation'},
{ label: 'Mock practice',value:'mock_practice'},
];


return (
<div className="bg-white rounded-lg shadow-sm p-4 mb-6 border border-gray-200">
<div className="flex flex-col md:flex-row gap-4 items-center justify-between">
<div className="flex-1 flex gap-4 w-full md:w-auto">
{/* Search Bar */}
<div className="flex-1 relative">
<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
<Input
type="search"
placeholder="Search by job title or company..."
value={filters.search}
onChange={(e) => setFilters({ ...filters, search: e.target.value})}
className="pl-10 pr-4 border border-gray-200"
/>
</div>

{/* Filter Toggle */}
<button
onClick={() => setShowFilters(!showFilters)}
className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm whitespace-nowrap"
>
<Filter className="w-3 h-3" />
Filters
<ChevronDown className={`w-4 h-4 transition-transform ${showFilters ? 'rotate-180' : ''}`} />
</button>
</div>

{/* View Mode Toggle */}
<div className="flex gap-2 bg-gray-100 p-1 rounded-lg">
<button
onClick={() => setViewMode('list')}
className={`flex items-center text-sm gap-2 px-4 py-2 rounded-md transition-colors ${
viewMode === 'list' ? 'bg-white shadow-sm' : 'hover:bg-gray-200'
}`}
>
<List className="w-3 h-3" />
List
</button>
<button
onClick={() => setViewMode('calendar')}
className={`flex items-center text-sm gap-2 px-4 py-2 rounded-md transition-colors ${
viewMode === 'calendar' ? 'bg-white shadow-sm' : 'hover:bg-gray-200'
}`}
>
<CalendarDays className="w-3 h-3" />
Calendar
</button>
</div>
</div>

{/* Expandable Filters */}
{showFilters && (
<div className="mt-4 pt-4 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4">
<div>
<Select
label="Company"
options={companyOptions}
value={filters.company}
onChange={(e) => setFilters({ ...filters, company: e.target.value })}
/>
</div>

<div>
<Select
label="Status"
options={statusOptions}
value={filters.status}
onChange={(status) => setFilters({ ...filters, status })}
/>
</div>

<div>
<Select
label="Type"
options={typeOptions}
value={filters.type}
onChange={(type) => setFilters({ ...filters, type })}
/>
</div>

<div className="">
<Input
label="Date From"
type="date"
value={filters.dateFrom}
onChange={(e) => setFilters({ ...filters, dateFrom:e.target.value })}
className="mb-4 border border-gray-200"
/>
</div>

</div>
)}
</div>
);
};

export default FilterSection;